// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"X3-z","colorTextValue":"Y3-z","swatches":"Z3-z","collapseLink":"_3-z","isCollapsed":"a4-z","dropdown":"b4-z","disabled":"c4-z"};